// ----------------------------------------------------------------------------
// Nombre del Programa : Enlaces
// Autor               : Daniel Medina
// Compania            : Forward
// Proyecto/Procliente : P-24-1448-21                      Fecha: 18/AGO/2023
// Descripcion General : Clase que se utiliza la vista y funciones de el listado de los enlaces
// Programa Dependiente: N/A
// Programa Subsecuente: N/A
// Cond. de ejecucion  : N/A
// Dias de ejecucion   : N/A                                 Horario: N/A
//                              MODIFICACIONES
// ----------------------------------------------------------------------------
// Numero de Parametros:
// Parametros Entrada  :                                    Formato:
//
// Parametros Salida   : N/A                                Formato: N/A
// ----------------------------------------------------------------------------

import './Enlaces.scss';
import 'react-status-alert/dist/status-alert.css';
import { useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { StatusAlertService } from 'react-status-alert';
import Simplert from 'react-simplert';
import { EnlacesProps } from '../../interfaces/enlacesInterfaces';
import { getEnlaces, postEnlace, deleteEnlaces } from '../../Services/EnlacesService';

export const Enlaces = () => {
  const [enlaces, setEnlaces] = useState<EnlacesProps[]>([]);
  const [mostrarAlerta, setMostrarAlerta] = useState<boolean>(false);
  const [enlaceBorrar, setEnlaceBorrar] = useState<{
    idp: number;
    index: number;
  }>({
    idp: 0,
    index: 0,
  });

  useEffect(() => {
    cargarEnlaces();
  }, []);

  const cargarEnlaces = async () => {
    const response: any = await getEnlaces().catch(({ response }) => {
      const { data } = response;
      const noroles: EnlacesProps[] = [];
      setEnlaces(noroles);
    });
    if (response.data && response.data.data) {
      setEnlaces(response.data.data);
    }
  };

  const borrarEnlace = async (idp: number, index: number) => {
    setEnlaceBorrar({ idp: idp, index: index });
    setMostrarAlerta(true);
  };

  const confirmarBorrarEnlace = async () => {
    setMostrarAlerta(false);
    const response: any = await deleteEnlaces(enlaceBorrar.idp).catch(({ response }) => {
      const { data } = response;
      StatusAlertService.showError(data.meta.message);
    });
    if (response.data && response.data.data) {
      const enlacesnoeli = enlaces.filter(
        (enlaces) => enlaces.enlace_id !== enlaceBorrar.idp
      );
      setEnlaces(enlacesnoeli);
      StatusAlertService.showSuccess('Borrado Exitosamente');
    }
  };

  const cambiarPosicionEnlace = async (
    enlaceActual: EnlacesProps,
    enlaceCambiar: EnlacesProps
  ) => {
    let posicionActual = enlaceActual.orden;
    let posicionCambiar = enlaceCambiar.orden;

    enlaceActual.orden = posicionCambiar;
    enlaceCambiar.orden = posicionActual;

    const enlacesGuardar: EnlacesProps[] = [];
    enlacesGuardar.push(enlaceActual);
    enlacesGuardar.push(enlaceCambiar);

    const response: any = await postEnlace(enlacesGuardar).catch(({ response }) => {
      const { data } = response;
      enlaceActual.orden = posicionActual;
      enlaceCambiar.orden = posicionCambiar;
      setEnlaces([...enlaces]);
      StatusAlertService.showError(data.meta.message);
    });
    if (response.data && response.data.data) {
    }
  };

  return (
    <>
      <Simplert
        showSimplert={mostrarAlerta}
        type="info"
        title="¿Desea Eliminarlo?"
        message=""
        customCloseBtnText="Cancelar"
        customConfirmBtnText="Aceptar"
        customConfirmBtnClass="btn-confirm"
        customCloseBtnClass="btn-cerrar"
        disableOverlayClick={true}
        useConfirmBtn={true}
        onConfirm={() => confirmarBorrarEnlace()}
        onClose={() => setMostrarAlerta(false)}
      />
      <div className="m-5">
        <Row className="mb-2">
          <Col className="heading-1">Enlaces</Col>
        </Row>
        <Row className="mt-3">
          <Col>
            <Row>
              <Col className="heading-1">Enlaces directos</Col>
              <hr style={{ backgroundColor: '#000000', height: 2 }} />
            </Row>
            <Row>
              {enlaces.filter((enlaces) => enlaces.principal === true).length >
                0
                ? enlaces
                  .filter((enlaces) => enlaces.principal === true)
                  .sort((a, b) => (a.orden < b.orden ? -1 : 1))
                  .map((enlace, index) => (
                    <Col key={index} sm={3} className="mt-3">
                      <div className="herramienta">
                        <img src={enlace.urlImagen} />
                        <div className="info-herramienta">
                          {index > 0 ? (
                            <Button variant="secondary" className="me-2">
                              <div
                                className="material-icons"
                                onClick={() =>
                                  cambiarPosicionEnlace(
                                    enlace,
                                    enlaces
                                      .filter(
                                        (enlaces) =>
                                          enlaces.principal === true
                                      )
                                      .sort((a, b) =>
                                        a.orden < b.orden ? -1 : 1
                                      )[index - 1]
                                  )
                                }
                              >
                                arrow_left
                              </div>
                            </Button>
                          ) : (
                            ''
                          )}
                          <Button
                            variant="secondary"
                            className="me-1"
                            onClick={() =>
                              borrarEnlace(enlace.enlace_id, index)
                            }
                          >
                            <div className="material-icons">delete</div>
                          </Button>
                          <Link
                            to={'/enlaces/enlace'}
                            state={{
                              idenlace: enlace.enlace_id,
                              principal: true,
                            }}
                          >
                            <Button variant="secondary" className="me-2">
                              <div className="material-icons">edit</div>
                            </Button>
                          </Link>
                          {index <
                            enlaces.filter(
                              (enlaces) => enlaces.principal === true
                            ).length -
                            1 ? (
                            <Button variant="secondary">
                              <div
                                className="material-icons"
                                onClick={() =>
                                  cambiarPosicionEnlace(
                                    enlace,
                                    enlaces
                                      .filter(
                                        (enlaces) =>
                                          enlaces.principal === true
                                      )
                                      .sort((a, b) =>
                                        a.orden < b.orden ? -1 : 1
                                      )[index + 1]
                                  )
                                }
                              >
                                arrow_right
                              </div>
                            </Button>
                          ) : (
                            ''
                          )}
                        </div>
                      </div>
                    </Col>
                  ))
                : ''}
              <Col sm={3} className="mt-3">
                <Link
                  to={'/enlaces/enlace'}
                  state={{ idenlace: 0, principal: true }}
                >
                  <div className="agregar-herramienta">
                    <div className="info-agregarherramienta">
                      <div className="material-icons icon me-2">link</div>
                      <span className="titulo">Agregar enlace</span>
                    </div>
                  </div>
                </Link>
              </Col>
            </Row>
            <Row className="mt-5">
              <Col className="heading-1">Conéctate</Col>
              <hr style={{ backgroundColor: '#000000', height: 2 }} />
            </Row>
            <Row>
              {enlaces.filter((enlaces) => enlaces.principal === false).length >
                0
                ? enlaces
                  .filter((enlaces) => enlaces.principal === false)
                  .sort((a, b) => (a.orden < b.orden ? -1 : 1))
                  .map((enlace, index) => (
                    <Col key={index} sm={2} className="mt-3">
                      <div className="herramienta">
                        <img src={enlace.urlImagen} />
                        <div className="info-otraherramienta">
                          {index > 0 ? (
                            <div
                              className="material-icons me-2"
                              onClick={() =>
                                cambiarPosicionEnlace(
                                  enlace,
                                  enlaces
                                    .filter(
                                      (enlaces) => enlaces.principal === false
                                    )
                                    .sort((a, b) =>
                                      a.orden < b.orden ? -1 : 1
                                    )[index - 1]
                                )
                              }
                            >
                              arrow_left
                            </div>
                          ) : (
                            ''
                          )}
                          <div
                            className="material-icons me-2"
                            onClick={() =>
                              borrarEnlace(enlace.enlace_id, index)
                            }
                          >
                            delete
                          </div>
                          <Link
                            className="linkeditar"
                            to={'/enlaces/enlace'}
                            state={{
                              idenlace: enlace.enlace_id,
                              principal: false,
                            }}
                          >
                            <div className="material-icons me-2">edit</div>
                          </Link>
                          {index <
                            enlaces.filter(
                              (enlaces) => enlaces.principal === false
                            ).length -
                            1 ? (
                            <div
                              className="material-icons me-2"
                              onClick={() =>
                                cambiarPosicionEnlace(
                                  enlace,
                                  enlaces
                                    .filter(
                                      (enlaces) => enlaces.principal === false
                                    )
                                    .sort((a, b) =>
                                      a.orden < b.orden ? -1 : 1
                                    )[index + 1]
                                )
                              }
                            >
                              arrow_right
                            </div>
                          ) : (
                            ''
                          )}
                        </div>
                      </div>
                    </Col>
                  ))
                : ''}
              <Col sm={2} className="mt-3">
                <Link
                  to={'/enlaces/enlace'}
                  state={{ idenlace: 0, principal: false }}
                >
                  <div className="agregar-herramienta">
                    <div className="info-agregarherramienta">
                      <div className="material-icons icon me-2">link</div>
                      <span className="titulo">Agregar enlace</span>
                    </div>
                  </div>
                </Link>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    </>
  );
};
